import script from "./subscriptionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./subscriptionList.vue?vue&type=script&setup=true&lang=ts"

import "./subscriptionList.vue?vue&type=style&index=0&id=70bbf0ee&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3714422101/src/github.com/teknologi-kartu/crm-web-admin-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70bbf0ee"]])

export default __exports__